import { deepFreeze } from 'utils/deepFreeze';

const initialState = deepFreeze({
  confirming: false,
  inProgress: false,
});

export default initialState;
